// extracted by mini-css-extract-plugin
module.exports = {"view":"Activities_view__2NOrG","detailLevel":"Activities_detailLevel__JVFLB","activities":"Activities_activities__3Q5nV"};